import React, { useEffect } from "react";
import { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Navigation from "../components/onboarding/Navigation";
import useStore from "../zustandstore";
export const Layout = (props: any) => {
  const showNav = useStore((state: any) => state.showNav);
  const setShowNav = useStore((state: any) => state.setShowNav);
  const location = useLocation();

  useEffect(() => {
    setShowNav(false);
  }, [location.pathname, setShowNav]);

  return (
    <Fragment>
      <div className="dashboard">
        <ToastContainer />
        <div className="booking-wrapper Navigation_bar">
          {showNav && <Navigation />}
        </div>

        <div
          className="loader"
          id="full_loader"
          style={{
            display: "none",
            position: "fixed",
            height: "100vh",
            width: "100%",
            top: "0px",
            left: "0px",
            backgroundColor: "#0000006e",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src="/static/loader.gif" width="100px" height="100px" alt="" />
        </div>

        {!showNav && props.children}
      </div>
    </Fragment>
  );
};
